import { render, staticRenderFns } from "./ui-lang-choice.vue?vue&type=template&id=0481bf08&scoped=true&"
import script from "./ui-lang-choice.vue?vue&type=script&lang=js&"
export * from "./ui-lang-choice.vue?vue&type=script&lang=js&"
import style0 from "./ui-lang-choice.vue?vue&type=style&index=0&id=0481bf08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481bf08",
  null
  
)

export default component.exports